module.exports = __webpack_public_path__ + "img/role_privilege.bed1e1c7.svg";